export const buildRocheTransactionsFetchArgs = ({
    statusFilter,
    page,
    textToSearch,
    startDate,
    endDate,
    propertySort,
    contractSortDirection,
}) => [
    { statusFilter },
    page + 1,
    textToSearch,
    startDate,
    endDate,
    propertySort
        ? contractSortDirection === 'asc'
            ? `order_by=${propertySort}`
            : `order_by=-${propertySort}`
        : '',
];

export const buildPaymentResultsSummary = ({
    transactions = [],
    trackedErroredTransactions = [],
    selectedCount = 0,
}) => {
    const trackedErrors = Array.isArray(trackedErroredTransactions)
        ? trackedErroredTransactions
        : [];
    const erroredTransactions = trackedErrors.length
        ? trackedErrors
        : transactions.filter((transaction) => transaction?.errors?.length > 0);
    const successfulTransactions = transactions.filter(
        (transaction) =>
            !erroredTransactions.some(
                (erroredTransaction) => String(erroredTransaction.id) === String(transaction.id),
            ),
    );

    if (erroredTransactions.length === 0 && transactions.length > 0) {
        return {
            allSuccessful: true,
            successfulTotal: successfulTransactions.length,
            errorTotal: 0,
            errors: [],
            singleErroredTransactionIds: [],
        };
    }

    return {
        allSuccessful: false,
        successfulTotal: successfulTransactions.length,
        errorTotal: erroredTransactions.length,
        errors: erroredTransactions.flatMap((transaction) =>
            (transaction.errors || []).map(
                (error) => `ID ${transaction.id} - ${error?.description}`,
            ),
        ),
        singleErroredTransactionIds:
            erroredTransactions.length > 0 && selectedCount === 1
                ? erroredTransactions.map((transaction) => transaction.id)
                : [],
    };
};
